import React, {useContext} from 'react';
import {BoShowContext} from "../context/bo-show-context.jsx";
import {BoKeys} from "../../resources/bo-keys.js";
import moment from "moment";

const BoShowStatusWarning = ({ boName }) => {
    const {dataFetch, isSync, lastSync, syncId, offsetUTC} = useContext(BoShowContext);
    const status = dataFetch?.bogcm?.bogcm?.status ?? ""
    const boSyncs = dataFetch?.syncs;

    const bogcmSyncRetentionDays = dataFetch?.bogcm?.bogcmSyncRetentionDays;
    const idCreationDt = dataFetch?.bogcm?.bogcm?.idCreationDt;

    const daysLeft = moment(idCreationDt).add(bogcmSyncRetentionDays, 'days').diff(moment(), 'days');

    const syncVersion = () => {
        const sync = boSyncs.find(sync => sync.id === syncId);
        if (!sync) return null;

        const dtLastSync = moment.utc(sync.dtLastSync).utcOffset(offsetUTC).format('DD/MM/YYYY HH:mm');

        return (
            <>
                <br/>
                Versão editada por {sync.userName} em {dtLastSync}
            </>
        )
    }

    return (
        <>
            {
                boSyncs && boSyncs.length > 0 &&
                <article className={"print:hidden"}>
                    <h3 className={"text-center min-h-7.5 border border-[#a7d4ff] rounded-md text-[#1c657d]! bg-[#a7d4ff]"}>
                        As versões não enviadas do {boName} serão excluídas {daysLeft > 0 ? `em ${daysLeft} ${daysLeft === 1 ? "dia" : "dias"}` : "em breve"}.
                    </h3>
                </article>
            }
            {
                (status !== "APPROVED" || status === "APPROVED" && isSync) &&
                <article id={"status-warning"}>
                    <h3 className={"text-center min-h-[30px] border border-[#ff5353] rounded-md !text-white bg-[#ff5353]"}>
                        Documento sem valor legal, apenas para conferência. (status: {BoKeys[status] ?? status})
                        {
                            !lastSync && isSync && syncVersion()
                        }
                    </h3>
                </article>
            }
        </>
    );
};


export default BoShowStatusWarning;